module.exports = __webpack_public_path__ + "img/maTouQin4.8ca18799.png";